import React from "react";
import { Button } from "./../../common/Button/Button";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import { useEffect, useState } from "react";
import api from "../../utils/api";
import Spinner from "../../common/Spinner/Spinner";
import { toast } from "react-toastify";

export default function ReportContainer(props) {
  useEffect(() => {
    //make an api call to the server
    //for any initialisation data.
  }, []);
  const [formData, setFormData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [toDate, setToDate] = useState();
  const [fromDate, setFromDate] = useState();
  const onInputChange = (name, value) => {
    console.log("sadasdas");
    const form_data = { ...formData, [name]: value };
    setFormData(form_data);
    console.log("setting the state");
  };

  const fetchAllServicesReport = () => {
    console.log("fromdate, to date", fromDate, toDate);
    setLoading(true);
    try {
        const payload = {fromDate, toDate}
      api
        .getAllServicesReportView(payload)
        .then(({ data }) => {
        //   window.open(data["generated_file"], "_self");
          setLoading(false);
        })
        .catch((error) => {
          console.log(error.status);
          setLoading(false);
          toast("Server error", {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
          });
        });
    } catch {
      setLoading(false);
      toast("Server error.", {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
      });
    }
  };

  return (
    <>
      {isLoading && <Spinner className="center-screen" />}
      <div className={`${isLoading && "set-opacity"}`}>
        <br></br>
        <h5>All Services Report: </h5>
        <label className="m-2">From Date :</label>
        <ReactDatePicker
          name="fromDate"
          selected={fromDate}
          maxDate={new Date()}
          onChange={(date) => setFromDate(date)}
        />
        <label className="m-2">To Date :</label>
        <ReactDatePicker
          name="toDate"
          selected={toDate}
          maxDate={new Date()}
          onChange={(date) => setToDate(date)}
        />
        <Calendar />
        <Button className="m-2" onClick={fetchAllServicesReport}>
          Download Report
        </Button>
        &nbsp;&nbsp;&nbsp;
      </div>
    </>
  );
}
